// ----------------------------------------------------------------------------
// Template: Collection
// ----------------------------------------------------------------------------
// 
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/collection-driver/collection-driver';
import 'snippets/card/card';
import 'snippets/pagination/pagination';
import 'snippets/powertools-filter/powertools-filter';

import 'sections/page-header/page-header';
import 'sections/footer/footer';


// Styles
import './_collection.scss';

